<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.showButton" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="showButton" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.iconLeft" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="iconLeft" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.iconRight" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="iconRight" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text>
            <container :class="['py-3']">
              <chip-input
                @left-icon-click="onLeftIconClick"
                @right-icon-click="onRightIconClick"
                @input="onInput"
                label-color="white"
                :disabled="disabled"
                :show-button="showButton"
                :placeholder="$lang.typeAndHitEnter"
                :icon-left="iconLeft ? 'guitar-pick-outline' : null"
                :icon-right="iconRight ? 'tag' : null"
                :color="$root.$colors.primary"
                :color-lightness="$root.$colors.bgColorLightness"
                :chips="chips" />
            </container>
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">v-model: {{ chips }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageChipInput',
  mixins: [
    methods
  ],
  data () {
    return {
      chips: [],
      iconLeft: false,
      iconRight: false,
      showButton: false,
      disabled: false
    }
  },
  mounted () {
    this.getExternalData('chip-input.json', 'chips')
  },
  methods: {
    onInput ($event) {
      this.log('input', 'chip-input', $event)
    },
    onRightIconClick () {
      this.log('right-icon-click', 'chip-input', 'right icon clicked')
    },
    onLeftIconClick () {
      this.log('left-icon-click', 'chip-input', 'left icon clicked')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/chip-input.vue